<template>
	<div class="account">
		<filter-panel :data="groups" @search="filterChange" v-if="groups.multiples"></filter-panel>
		<el-row type="flex" class="row-bg" justify="end">
			<!-- <el-button size="medium" @click="dialogVisible = true" type="primary">新增</el-button> -->
			<el-button size="medium" @click="showAddTweets" type="primary">新增推文</el-button>
		</el-row>
		<data-list
			:loading="loading"
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="column"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>
		<el-dialog
			:title="tweets.id ? '编辑推文组' : '新建推文组'"
			:close-on-click-modal="false"
			:visible.sync="dialogVisible"
			@closed="close"
			width="600px"
		>
			<form-combination :form-data="formData" ref="formData" label-width="120px">
			</form-combination>
			<div slot="footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submit" v-if="!tweets.id" :loading="btnLoading"
					>确认</el-button
				>
			</div>
		</el-dialog>
		<el-dialog
			title="更改时间"
			:close-on-click-modal="false"
			:visible.sync="modifyVisible"
			@closed="modifyClose"
			width="600px"
		>
			<form-combination :form-data="modifyForm" ref="modifyForm" label-width="120px">
			</form-combination>
			<div slot="footer">
				<el-button @click="modifyVisible = false">取消</el-button>
				<el-button type="primary" @click="modifySubmit" :loading="btnLoading">确认</el-button>
			</div>
		</el-dialog>
		<social-preview :id="twitterId" :visible="visible" @closed="closed"></social-preview>

		<el-dialog :visible.sync="videoPreviewUrlVisible" :append-to-body="true">
			<video width="100%" height="500px" :src="videoPreviewUrl" controls></video>
		</el-dialog>

		<!-- 推文表单弹窗 -->
		<tweetsFormDialog
			ref="tweetsFormDialog"
			dialogWidth="800px"
			title="新建推文"
		></tweetsFormDialog>
	</div>
</template>
<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import mediafax from '@/backend/services/account/mediafax';
import skyDatePicker from '@/components/iglobalwin/formComponents/sky-date-picker.vue';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import { validRequired } from '@/common/elementValid';
import { userType, tweetsStatus } from '@/common/dictionary';
import { getDateList, urlReplace } from '@/common/util.js';
import tweetsAPI from '@/backend/services/account/tweets';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
import beforeRouteEnter from '@/mixins/beforeRouteEnter.js';
import tweetStatus from '@/components/iglobalwin/dataList/account/tweetStatus.vue';
import customerMinxins from '@/mixins/customer';
import vm from '@/common/confirm.js';
import socialPreview from '@/components/socialMedia/preview.vue';
import facebookText from './component/facebookText.vue';
import assets from './component/assets.vue';

import { mapGetters } from 'vuex';
import tweetsFormDialog from './component/tweetsFormDialog.vue';

// import { debug } from "util";
const page = listPageCreate({
	searchConfig: {
		api: api.tweet.getTweetsList,
		method: 'POST',
	},
	getQuery(params, that) {
		if (typeof params.customerId === 'undefined' && that.$route.query.id) {
			params.customerId = that.$route.query.id;
		}
		return params;
	},
});
export default {
	name: 'socialMedialTweets',
	props: {},
	mixins: [page, customerMinxins, beforeRouteEnter],
	components: {
		filterPanel,
		skyDatePicker,
		formCombination,
		socialPreview,
		tweetsFormDialog,
	},
	data() {
		const that = this;
		const tweets = {
			action: '',
			content: '',
			customerId: '',
			gifImageFileName: [],
			imageFileName: [],
			mediaPlatforms: [],
			sendDateTime: '',
			shareDescription: '',
			shareTitle: '',
			shareUrl: '',
			videoFileName: [],
			assets: [],
		};
		const column = [
			{
				//1-已推,2-待推,3-失败
				label: '推文状态',
				type: 'mapping',
				bind: 'status',
				mapType: 'iconfont',
				width: 100,
				align: 'left',
				size: { fontSize: '23px' },
				parentEvent: row => {
					let status = [
						{ label: 'fasongchenggong', value: 1 },
						{ label: 'daifasong', value: 2 },
						{ label: 'fasongshibai1', value: 3 },
					];
					let obj = status.find(item => row == item.value);
					return obj ? obj.label : '-';
				},
				colors: row => {
					let status = [
						{ label: { color: '#78CE4D' }, value: 1 },
						{ label: { color: '#FCC262' }, value: 2 },
						{ label: { color: '#FF5A5A' }, value: 3 },
					];
					let obj = status.find(item => row == item.value);
					return obj ? obj.label : {};
				},
				message: row => {
					let status = [
						{ label: '已推', value: 1 },
						{ label: '待推', value: 2 },
						{ label: '失败', value: 3 },
					];
					let obj = status.find(item => row == item.value);
					return obj ? obj.label : '-';
				},
			},
			{
				type: 'custInfo',
				label: '客户名称',
				main: 'customerName',
			},
			// {
			// 	label: '社媒主体',
			// 	bind: 'subject',
			// 	align: 'center',
			// 	width: 100,
			// },
			{
				label: '账号信息',
				type: 'custInfo',
				align: 'center',
				text: [
					{
						label: '运营账号',
						bind: 'accountName',
						style: {
							'text-align': 'center',
						},
					},
					{
						label: '客户账号',
						bind: 'pageName',
						style: {
							'text-align': 'center',
						},
					},
				],
			},
			{
				label: '发布者',
				bind: 'createrName',
				minWidth: '100px',
				align: 'center',
			},
			{
				type: 'iconbutton',
				label: '社媒平台',
				width: 100,
				iconlist: [
					// 社媒平台对接
					{
						id: 0,
						name: 'facebook1',
						style: () => {
							return { color: '#0766ff' };
						},
						showButton: row => {
							let { mediaPlatform } = row;
							return mediaPlatform === '26';
						},
					},
					{
						id: 1,
						name: 'twitter1',
						style: () => {
							return { color: '#000' };
						},
						showButton: row => {
							let { mediaPlatform } = row;
							return mediaPlatform === '27';
						},
					},
					{
						id: 2,
						name: 'linkedin1',
						style: () => {
							return { color: '#0b66c2' };
						},
						showButton: row => {
							let { mediaPlatform } = row;
							return mediaPlatform === '25';
						},
					},
					{
						id: 3,
						name: 'youtube2',
						style: () => {
							return { color: '#ff0000' };
						},
						showButton: row => {
							let { mediaPlatform } = row;
							return mediaPlatform === '28';
						},
					},
					{
						id: 4,
						name: 'tikTok',
						style: () => {
							return { color: '#000' };
						},
						showButton: row => {
							let { mediaPlatform } = row;
							return mediaPlatform === '29';
						},
					},
				],
				minWidth: 150,
			},
			{
				label: '推送日期',
				bind: 'sendTime',
				width: 180,
				align: 'center',
			},
			{
				label: '社媒信息',
				width: 220,
				align: 'center',
				bind: 'content',
				type: 'preview',
				preview: function (row) {
					that.defaultKey = row.customerName;
					if (row.status == 1) {
						that.twitterId = row.thirdpartyTweetsId;
						that.$store.commit('SET_SERVICEID', row.serviceId);
						that.visible = true;
					} else {
						tweetsAPI.getTweetsDetail({ id: row.id }).then(val => {
							if (val.data) {
								val.data.assets = [];
								if (val.data.imageFileList) {
									val.data.assets = val.data.imageFileList.map(item => {
										return {
											...item,
											type: 'image',
										};
									});
								}
								if (val.data.videoFile) {
									val.data.assets = [
										{
											...val.data.videoFile,
											type: 'video',
										},
									];
								}
								that.tweets = val.data;
								that.setFormData(true);
								that.dialogVisible = true;
							}
						});
					}
				},
				videoPreview: url => {
					this.videoPreviewUrlVisible = true;
					this.videoPreviewUrl = url;
				},
			},
			{
				type: 'custom',
				componentName: tweetStatus,
				label: '操作',
				width: 240,
				watchTweets: function (row) {
					window.open(row.thirdpartyTweetsUrl);
				},
				changeTime: function (row) {
					that.modifyVisible = true;
					that.setModifyForm(row);
				},
				showStatus(row) {
					let { mediaPlatform } = row;
					return mediaPlatform === '26';
				},
				retry(row) {
					that
						.$confirm('是否重新发布?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						})
						.then(() => {
							tweetsAPI.retryTweets({ id: row.id }).then(() => {
								that.$message({
									type: 'success',
									message: '发布成功!',
								});
								that.query();
							});
						})
						.catch(() => {
							that.$message({
								type: 'info',
								message: '已取消删除',
							});
						});
				},
				async publish(row) {
					try {
						let confirm = await vm._confirm('是否立即发布？');
						if (confirm) {
							tweetsAPI
								.retryTweets({ id: row.id })
								.then(res => {
									if (res) vm._success('发布成功');
									that.query();
								})
								.catch(err => {
									if (err) vm._info('发布失败');
								});
						}
					} catch (error) {
						vm._info('取消发布');
						console.error(error);
					}
				},
				async remove(row) {
					try {
						let confirm = await vm._confirm('是否确认删除该推文');
						if (confirm) {
							tweetsAPI
								.removeTwitter({ id: row.id })
								.then(res => {
									if (res) vm._success('删除成功');
									that.query();
								})
								.catch(err => {
									if (err) vm._info('删除失败');
								});
						}
					} catch (error) {
						vm._info('取消删除');
						console.error(error);
					}
				},
			},
		];
		return {
			groups: {},
			btnLoading: false,
			tweets: tweets,
			column: column,
			dialogVisible: false,
			reportVisible: false,
			modifyVisible: false,
			modifyForm: {},
			mediaForm: {},
			custName: '',
			defaultKey: null,
			formData: {},
			twitterId: '',
			visible: false,
			serviceId: '',
			videoPreviewUrlVisible: false,
			videoPreviewUrl: '',
		};
	},
	computed: {
		...mapGetters(['customerId', 'customerName']),
	},
	watch: {
		'formData.customerId.value'(val) {
			if (val) {
				!this.tweets.id && (this.formData.serviceId.value = undefined);
				mediafax
					.getMediafaxSubject({
						customerId: val,
					})
					.then(val => {
						if (val.data) {
							this.formData.serviceId.options = val.data;
						}
					});
			}
		},
	},
	mounted() {
		let params = this.$route.query;
		var defaultKey;
		if (params.id) {
			defaultKey = decodeURIComponent(params.custName);
			this.defaultKey = decodeURIComponent(params.custName);
			this.tweets.customerId = params.id;
		}
		this.groups = {
			others: [
				{
					tagName: 'sky-select',
					placeholder: '请选择社媒平台',
					label: '社媒平台',
					options: [
						{ label: '全部媒体', value: '' },
						{ label: 'Facebook', value: '26' },
						{ label: 'TikTok', value: '29' },
						{ label: 'X（Twitter）', value: '27' },
						{ label: 'LinkedIn', value: '25' },
						{ label: 'YouTube', value: '28' },
					],
					prop: 'mediaPlatform',
					value: '',
				},
				{
					label: '推送时间',
					startPlaceholder: '开始日期',
					endPlaceholder: '结束日期',
					prop: ['startDate', 'endDate'],
					tagName: 'sky-date-picker',
					type: 'daterange',
					value: [],
				},
				{
					tagName: 'sky-input',
					placeholder: '发布者',
					label: '发布者',
					prop: 'createrName',
					value: '',
					filterable: true,
					remote: false,
				},
			],
			multiples: [
				{
					defaultText: '推文状态',
					label: '推文状态',
					prop: 'status',
					options: tweetsStatus,
					value: '',
				},
				{
					defaultText: '发布者类型',
					label: '发布者类型',
					prop: 'userType',
					options: userType,
					value: '',
				},
			],
		};
		this.setFormData();
	},
	methods: {
		close() {
			this.defaultKey = null;
			this.tweets = {
				action: 1,
				content: '',
				customerId: '',
				gifImageFileName: [],
				imageFileName: [],
				mediaPlatforms: [],
				sendDateTime: '',
				shareDescription: '',
				shareTitle: '',
				shareUrl: '',
				videoFileName: [],
				assets: [],
			};
			this.setFormData();
		},
		closed() {
			this.visible = false;
		},
		modifyClose() {},
		setFormData(preview) {
			let that = this;
			let formData = {
				customerId: {
					formType: 'customer-search',
					value: this.tweets.customerId,
					placeholder: '',
					label: '选择客户',
					defaultKey: this.defaultKey,
					options: [],
					rules: [validRequired(), 'change'],
				},
				serviceId: {
					label: '服务单',
					formType: 'sky-select',
					value: this.tweets.serviceId,
					props: {
						label: 'domain',
						value: 'id',
					},
					options: [],
					setOptionLeftLabel(row) {
						return `${row.domain || '-'}(${row.serviceCode})`;
					},
				},
				action: {
					label: '推送类型',
					formType: 'sky-select',
					value: this.tweets.action,
					options: [
						{ label: '实时推送', value: 1 },
						{ label: '定时推送', value: 2 },
					],
				},
				sendDateTime: {
					label: '推送时间',
					formType: 'sky-date-picker',
					value: getDateList(1, 'YYYY-MM-DD HH:mm:ss')[0].value,
					type: 'datetime',
					valueFormat: 'yyyy-MM-dd HH:mm:ss',
					displayWith: form => {
						return form.action.value == 2;
					},
				},
				content: {
					label: '编辑内容',
					formType: facebookText,
					value: this.tweets.content,
					fileChange: list => {
						that.tweets.assets = list;
					},
					list: this.tweets.assets,
				},
				assets: {
					formType: assets,
					value: this.tweets.assets,
					displayWith() {
						return that.tweets.assets.length > 0;
					},
				},
			};
			if (preview) {
				formData = _.each(formData, item => {
					item.readOnly = true;
					item.disabled = true;
				});
			}
			this.formData = formData;
		},
		setModifyForm(row) {
			this.modifyForm = {
				id: row.id,
				noProp: {
					label: '原发布时间',
					formType: 'sky-input',
					value: row.sendTime,
					disabled: true,
				},
				sendDateTime: {
					label: '更改时间',
					formType: 'sky-date-picker',
					value: getDateList(1, 'YYYY-MM-DD HH:mm:ss')[0].value,
					type: 'datetime',
					valueFormat: 'yyyy-MM-dd HH:mm:ss',
				},
			};
		},
		submit() {
			this.btnLoading = true;
			let requestApi = api.tweet.addTweets;
			let type = 'Post';
			simpleFormPageCreate(
				{
					api: requestApi,
					type: type,
					data: this.formData,
					config: {
						timeout: 120000,
					},
				},
				res => {
					let data = {};
					let obj = Object.assign({}, res);
					let assets = obj.assets;
					if (assets && assets.length > 0) {
						if (assets[0].type == 'image') {
							data.imageFileList = [];
							assets.forEach(item => {
								data.imageFileList.push({
									fileName: item.fileName,
									ossName: item.ossName,
									url: item.url,
								});
							});
						}
						if (assets[0].type == 'video') {
							data.videoFile = {
								fileName: assets[0].fileName,
								ossName: assets[0].ossName,
								url: assets[0].url,
							};
						}
					}
					data = {
						...data,
						...obj,
						platformList: ['26'],
					};
					delete data.assets;
					return data;
				}
			)
				.submit()
				.then(() => {
					this.btnLoading = false;
					this.dialogVisible = false;
					this.$message.success('发送推文成功');
					this.query();
				})
				.catch(error => {
					this.$message.error('发送推文失败');
					this.btnLoading = false;
					this.query();
				});
		},
		modifySubmit() {
			this.btnLoading = true;
			let type = 'Patch';
			simpleFormPageCreate(
				{
					api: urlReplace(api.tweet.modifyTwitter, { id: this.modifyForm.id }),
					type: type,
					data: this.modifyForm,
				},
				res => {
					let obj = Object.assign({}, res);
					this.$delete(obj, 'noProp');
					return obj;
				}
			)
				.submit()
				.then(() => {
					this.btnLoading = false;
					this.modifyVisible = false;
					vm._success('修改成功');
					this.query();
				})
				.catch(() => {
					vm._error('修改失败');
					this.btnLoading = false;
				});
		},
		formatUrls(list) {
			return list;
		},
		// 新增推文弹窗显示
		async showAddTweets() {
			let { customerId, customerName } = this;
			let { cancel } = await this.$refs.tweetsFormDialog.show({
				customerId,
				customerName: customerId ? customerName : '',
				assets: [],
			});

			if (!cancel) this.query();
		},
	},
};
</script>
<style lang="scss" scoped>
.row-bg {
	background: #fff;
	margin: 10px 0;
	padding: 10px;
}
</style>
